import { render, staticRenderFns } from "./GiveAndAskCategories.vue?vue&type=template&id=45b515dc"
import script from "./GiveAndAskCategories.vue?vue&type=script&lang=js"
export * from "./GiveAndAskCategories.vue?vue&type=script&lang=js"
import style0 from "./GiveAndAskCategories.vue?vue&type=style&index=0&id=45b515dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports